import React from 'react';
import { Box } from '@mui/material';
import { MoSpacing } from '@motivo/guanyin/src/components';
import { ResultOf } from ':src/graphql';
import { userDetailsByIdQuery } from '../../graphql/queries';
import ZeusUserLink from '../shared/ZeusUserLink';
import { Section } from '../Section';

type User = NonNullable<ResultOf<typeof userDetailsByIdQuery>['userById']>;

interface SupervisorsSectionProps {
  user: User;
}

export default function SupervisorsSection({ user }: SupervisorsSectionProps) {
  const supervisors = user.supervisorMatches;
  const supervisorCount = supervisors.length;

  if (supervisorCount === 0) {
    return null;
  }

  return (
    <Section
      title="Supervisors"
      count={supervisorCount > 0 ? supervisorCount : undefined}
      summaryLink={{
        label: 'View all matches in Zeus →',
        path: `/users/${user.id}/matches`,
      }}
    >
      <MoSpacing y={1}>
        {supervisors.map((match) => (
          <Box key={match.id}>
            <ZeusUserLink user={match.supervisor} />
          </Box>
        ))}
      </MoSpacing>
    </Section>
  );
}
